module.exports = __webpack_public_path__ + "assets/x-ray.0def6292.svg";